export default "__VITE_ASSET__DFoCIK5V__"